import Impresso  from './impresso.svg'
import  Radio  from './radio.svg'
import  Tv  from './tv.svg'
import  Web  from './web.svg'



export const Svg = {impresso:Impresso, radio:Radio, tv:Tv, web:Web}

export default Svg;